import { Pm2IndexResponse } from 'RtModels';
import { DefaultDataGridColumn } from 'RtUi/components/data/DataGrid/columns/DefaultDataGridColumn';
import { EntityIdDataGridColumn } from 'RtUi/components/data/DataGrid/columns/EntityIdDataGridColumn';
import { IntegerDataGridColumn } from 'RtUi/components/data/DataGrid/columns/IntegerDataGridColumn';
import { PercentDataGridColumn } from 'RtUi/components/data/DataGrid/columns/PercentDataGridColumn';
import { PillDataGridColumn } from 'RtUi/components/data/DataGrid/columns/PillDataGridColumn';
import {
	DataGridColumn,
	RowThemeColor
} from 'RtUi/components/data/DataGrid/types';

export const getPm2Columns = (): Array<DataGridColumn<Pm2IndexResponse>> => [
	EntityIdDataGridColumn({
		accessorKey: 'hostname',
		header: 'Host'
	}),
	DefaultDataGridColumn({
		accessorKey: 'uid',
		header: 'UserId',
		isHidden: true
	}),
	DefaultDataGridColumn({
		accessorKey: 'username',
		header: 'User'
	}),
	DefaultDataGridColumn({
		accessorKey: 'pmId',
		header: 'PM2 Id',
		size: 60
	}),
	DefaultDataGridColumn({
		accessorKey: 'processName',
		header: 'Process Name'
	}),
	DefaultDataGridColumn({
		accessorKey: 'pid',
		header: 'pid'
	}),
	PillDataGridColumn({
		accessorKey: 'status',
		header: 'Status',
		themeValues: {
			offline: RowThemeColor.DANGER,
			online: RowThemeColor.SUCCESS
		},
		defaultTheme: RowThemeColor.DANGER
	}),
	IntegerDataGridColumn({
		accessorKey: 'restartCount',
		header: 'Restarts',
		size: 60
	}),
	DefaultDataGridColumn({
		accessorKey: 'started',
		header: 'Last Start'
	}),
	DefaultDataGridColumn({
		accessorKey: 'startedTime',
		header: 'Last Start',
		isHidden: true
	}),
	IntegerDataGridColumn({
		accessorKey: 'killTimeout',
		header: 'Kill Ms'
	}),
	DefaultDataGridColumn({
		accessorKey: 'cron',
		header: 'Cron'
	}),
	DefaultDataGridColumn({
		accessorKey: 'rtxEnvVars',
		header: 'Rtx Envs'
	}),
	PercentDataGridColumn({
		accessorKey: 'cpuPercent',
		header: 'cpu%'
	}),
	DefaultDataGridColumn({
		accessorKey: 'memoryUsage',
		header: 'Memory Used'
	}),
	IntegerDataGridColumn({
		accessorKey: 'memoryUsageBytes',
		header: 'Memory bytes',
		isHidden: true
	})
];
